import styled, { css, keyframes } from 'styled-components';
var rotate = keyframes(["100%{transform:rotate(360deg);}"]);
var dash = keyframes(["0%{stroke-dasharray:1,200;stroke-dashoffset:0;}50%{stroke-dasharray:89,200;stroke-dashoffset:-35px;}100%{stroke-dasharray:89,200;stroke-dashoffset:-124px;}"]);

var getColour = function getColour(props) {
  var kind = props.kind,
      theme = props.theme;

  switch (kind) {
    default:
    case 'default':
      {
        return theme.color.palette['brand-2'];
      }

    case 'primary':
      {
        return theme.color.alias.cta.primary.default.text;
      }

    case 'secondary':
      {
        return theme.color.alias.cta.secondary.default.text;
      }
  }
};

var Spinner = styled.div.withConfig({
  displayName: "Spinnerstyles__Spinner",
  componentId: "qtdy9y-0"
})(["position:absolute;width:", ";height:", ";", ""], function (props) {
  return "".concat(props.size, "px");
}, function (props) {
  return "".concat(props.size, "px");
}, function (props) {
  return css(["", ""], props.centered && css(["top:0;left:50%;transform:translate(-50%,-50%);"]));
});
var SVG = styled.svg.withConfig({
  displayName: "Spinnerstyles__SVG",
  componentId: "qtdy9y-1"
})(["&&{animation:", " 2s linear infinite;transform-origin:center center;width:", ";height:", ";position:relative;}"], rotate, function (props) {
  return "".concat(props.size, "px");
}, function (props) {
  return "".concat(props.size, "px");
});
var Circle = styled.circle.withConfig({
  displayName: "Spinnerstyles__Circle",
  componentId: "qtdy9y-2"
})(["stroke-dasharray:1,200;stroke-dashoffset:0;animation:", " 1.5s ease-in-out infinite;stroke-linecap:round;stroke:", ";@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){stroke-dasharray:15,200;}"], dash, function (props) {
  return getColour(props);
});
export { Circle, Spinner, SVG, getColour };